import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getHireStepByStep(tenant: Tenant): InfoCardProps[] {
	return [
		{
			title: "Jaký problém řešíte?",
			desc: "Vyslechneme si, jaký problém řešíte.",
		},
		{
			title: "Sestavíme vhodný tým",
			desc: "Domluvíme se s vámi, které specialisty potřebujete a na jak dlouho (pokud nevíte, rádi vám poradíme). Nejčastěji je pronajímáme na den, týden, měsíc nebo na celý kvartál. Možná je i spolupráce na dobu neurčitou.",
		},
		{
			title: "Definujeme si cíle",
			desc: "Odsouhlasíme si podmínky spolupráce, včetně ceny.",
		},
		{
			title: "Začneme hned",
			desc: "Naši specialisté pro vás začnou pracovat – buď samostatně, nebo společně s vaším interním týmem.",
		},
	];
}
